import React from "react";
import Highlighter from "react-highlight-words";

export default function highlightText(text: string, highlight: string) {
  if (!text) return text;

  const searchWords = highlight.split(/[\s\/\\\(\)\[\]]/);
  return (
    <Highlighter
      highlightClassName="bg-[#dff1d5] text-black p-0"
      searchWords={searchWords}
      autoEscape={true}
      textToHighlight={text}
    />
  );
}
